import { render, staticRenderFns } from "./orderNumber.vue?vue&type=template&id=87cdded6&scoped=true"
import script from "./orderNumber.vue?vue&type=script&lang=js"
export * from "./orderNumber.vue?vue&type=script&lang=js"
import style0 from "./orderNumber.vue?vue&type=style&index=0&id=87cdded6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cdded6",
  null
  
)

export default component.exports